import { Permissions } from '@/core/permissions/export';
import { NewsWidget, WidgetHost } from '@/core/widgets/export';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RouteObject } from 'react-router-dom';
import PipelineScroller from '@/modules/pipelines/components/scroller/pipeline-scroller';
import { faOilWell } from '@fortawesome/free-solid-svg-icons';
import { PipelineNotificationContextProvider } from '@/modules/pipelines/contexts/pipeline-notification-context';

export class PipelineAlertScrollerWidget implements NewsWidget {
  get defaultRoute(): string {
    return '';
  }

  get defaultTitle(): string {
    return 'Pipeline Notifications';
  }

  async hasPermission(permissions: string[]): Promise<boolean> {
    return !this.shouldHideToUser(permissions);
  }

  shouldHideToUser(permissions: string[]): boolean {
    return !permissions.includes(Permissions.PETRO_PIPELINES);
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get headerPanel(): JSX.Element {
    return (
      <span>
        <FontAwesomeIcon icon={faOilWell} /> Pipeline Notifications
      </span>
    );
  }

  get id(): string {
    return 'pipeline-notifications';
  }

  initialize(host: WidgetHost): void {}

  get routes(): RouteObject[] {
    return [
      {
        path: '/',
        element: (
          <PipelineNotificationContextProvider>
            <PipelineScroller />
          </PipelineNotificationContextProvider>
        ),
      },
    ];
  }

  get shortTitle(): JSX.Element {
    return this.headerPanel;
  }
}
